import { useEffect, useRef, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import ElipsisIcon from '@nv/images/design/elipsis-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './ActionDropdown.module.scss'

export const ActionDropdown = ({ values = [], onCallback, fileName }: any) => {
  const { t } = useTranslation()
  const [openActionDropdown, setOpenActionDropdown] = useState(false)
  const topicOpRef = useRef(null)

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (openActionDropdown && topicOpRef.current && !topicOpRef.current.contains(e.target)) {
        setOpenActionDropdown(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => document.removeEventListener('mousedown', checkIfClickedOutside)
  }, [openActionDropdown])

  useEffect(() => {
    if (openActionDropdown && topicOpRef.current) {
      const dropdownRect = topicOpRef.current.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      dropdownRect.bottom > viewportHeight && topicOpRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }, [openActionDropdown])

  return (
    <div className={styles['dropdown']}>
      <NVButton
        variant='iconOnly'
        icon={<ElipsisIcon />}
        onClick={() => setOpenActionDropdown((prev) => !prev)}
        ariaLabel={fileName ? t('buttons.actionDropdownForFile', { fileName }) : t('buttons.actionDropdown')}
      />

      {openActionDropdown && (
        <div className={clsx([styles['options'], styles['options--table-inline']])} ref={topicOpRef} role='menu'>
          {values.map((value, index) => (
            <NVButton
              key={index}
              variant='text'
              stretchContent={true}
              classes={{ container: styles['option'] }}
              icon={value.icon && value.icon}
              onClick={() => {
                value.callback ? value.callback() : onCallback(value.value)
                setOpenActionDropdown(false)
              }}
              text={value.label}
            />
          ))}
        </div>
      )}
    </div>
  )
}
